import { store } from '@store'
import { SessionState } from '@store/session/types'
import { BridgeService } from '@services/bridge'
import { IDataLayer, ElementAction } from '@utils/types'

const { utmCampaign } = store.getState().session as SessionState
const { convenioName } = store.getState().refinanciamento.contratos

interface TagProps {
  product?: string
  name?: string
  ref_type?: string
  installments_number?: string | number
  flow?: string
  only_app?: boolean
  content_name?: string
  tela?: string
  content_action?: string
  price?: string | number
  value?: string | number
  content_aba?: string
  content_grupo?: string | number
  content_conv?: string | number
  content_sel?: string
  contato?: string
  ref_figma: string
  content_id?: string
  link?: string
  screen?: string
  screen_name?: string
  utm_campaign?: string
  area?: string
  scenario?: string
  section?: string
  action_id?: string
  product_area?: string
  adjust_event_token?: number
  module?: string
  sub_section?: string
  step?: string
}

interface TagPropsWeb {
  element_name: string
  section_name: string
  element_action?: ElementAction
  c_page?: string
  step?: string | null
  scenario?: string
  section?: string
  redirect_url?: string | null
  product?: string
  product_area?: string
  profile?: string
  sub_section?: string
  input_name_1?: string | number | boolean
  input_value_1?: string | number | boolean
  input_name_2?: string | number | boolean
  input_value_2?: string | number | boolean
  input_name_3?: string | number | boolean
  input_value_3?: string | number | boolean
  input_name_4?: string | number | boolean
  input_value_4?: string | number | boolean
  input_name_5?: string | number | boolean
  input_value_5?: string | number | boolean
  input_name_6?: string | number | boolean
  input_value_6?: string | number | boolean
  input_name_7?: string | number | boolean
  input_value_7?: string | number | boolean
  input_name_8?: string | number | boolean
  input_value_8?: string | number | boolean
  input_name_9?: string | number | boolean
  input_value_9?: string | number | boolean
}

export default {
  enviarTagueamentoWeb: ({
    element_name = '',
    section_name = '',
    element_action,
    c_page = 'null',
    step = '',
    redirect_url = '',
    product = 'Payroll Loan',
    product_area = 'refin',
    profile = '',
    sub_section = '',
    scenario = '',
    input_name_1 = 'null',
    input_value_1 = 'null',
    input_name_2 = 'null',
    input_value_2 = 'null',
    input_name_3 = 'null',
    input_value_3 = 'null',
    input_name_4 = 'null',
    input_value_4 = 'null',
    input_name_5 = 'null',
    input_value_5 = 'null',
    input_name_6 = 'null',
    input_value_6 = 'null',
    input_name_7 = 'null',
    input_value_7 = 'null',
    input_name_8 = 'null',
    input_value_8 = 'null',
    input_name_9 = 'null',
    input_value_9 = 'null',
  }: TagPropsWeb) => {
    const dataLayer: IDataLayer = {
      event: 'ga_event_body_cred',
      params: {
        section_name: String(section_name),
        element_action,
        element_name: String(element_name),
        c_page,
        step: step || 'null',
        redirect_url: redirect_url || 'null',
        product,
        product_area,
        profile,
        sub_section,
        scenario,
      },
      params_input: {
        input_name_1,
        input_value_1,
        input_name_2,
        input_value_2,
        input_name_3,
        input_value_3,
        input_name_4,
        input_value_4,
        input_name_5,
        input_value_5,
        input_name_6,
        input_value_6,
        input_name_7,
        input_value_7,
        input_name_8,
        input_value_8,
        input_name_9,
        input_value_9,
      },
    }
    if (window.dataLayer) {
      window.dataLayer.push(dataLayer)
      // console.log(window.dataLayer.filter((event) => event.event === 'ga_event_body_cred'))
    }
  },
  enviarTagueamentoApp: ({
    content_name = '',
    screen,
    screen_name = '',
    tela,
    content_action = '',
    installments_number = '',
    value = '',
    content_aba = '',
    content_grupo = '',
    content_conv = '',
    content_sel = '',
    flow = '',
    ref_figma,
    ref_type,
    product = convenioName,
    link,
    name = convenioName,
    utm_campaign = utmCampaign || '',
    section = '',
    action_id = '',
    product_area = 'refin',
    adjust_event_token = 0,
    module = '',
    sub_section = '',
    step = '',
    scenario = '',
  }: TagProps) => {
    if (!BridgeService.isBrowser()) {
      BridgeService.requestAnalytics(name, {
        flow: flow.toUpperCase(),
        ref_figma,
        content_name: String(content_name),
        action_id: String(action_id || content_name),
        tela: String(tela),
        screen: String(screen),
        screen_name: String(screen_name),
        content_action: String(content_action),
        installments_number: String(installments_number),
        value: String(value),
        content_aba: String(content_aba),
        content_grupo: String(content_grupo).toUpperCase(),
        content_conv: String(content_conv).toUpperCase(),
        content_sel: String(content_sel),
        ref_type: String(ref_type),
        product,
        link: String(link),
        utm_campaign,
        scenario,
        section,
        adjust_event_token: String(adjust_event_token),
        module,
        product_area,
        sub_section,
        step,
      })
    }
  },
}
